<script setup lang="ts">
import type { INavItem } from '../model/types/footer-nav';
import {
  PUBLIC_OFFER_LINK,
  USER_AGREEMENT_LINK,
  PRIVACY_POLICY_LINK,
  PAYMENT_AND_RETURN_PRODUCT_RULES_LINK,
} from '@/shared/constants/documents';

const { t } = useI18n();

const itemsList: Ref<INavItem[]> = computed(() => [
  {
    id: 1,
    text: t('publicOffer'),
    url: PUBLIC_OFFER_LINK,
  },
  {
    id: 2,
    text: t('userAgreement'),
    url: USER_AGREEMENT_LINK,
  },
  {
    id: 3,
    text: t('personalDataProcessing'),
    url: PRIVACY_POLICY_LINK,
  },
  {
    id: 4,
    text: t('paymentAndReturnProductRules'),
    url: PAYMENT_AND_RETURN_PRODUCT_RULES_LINK,
  },
]);
</script>

<template>
  <ul class="footer-policy">
    <li v-for="item in itemsList" :key="item.id" class="footer-policy__item">
      <a
        class="footer-policy__link"
        :href="item.url"
        :aria-label="item.text"
        target="_blank"
      >
        {{ item.text }}
      </a>
    </li>
  </ul>
</template>

<style lang="less">
.footer-policy {
  display: inline-flex;
  align-items: center;
  gap: @size-x6;

  &__link {
    .color-change-hover();

    font-size: 15px;
    line-height: 100%;
    font-weight: 400;
    color: @color-oxford-blue;
  }

  @media @1280 {
    flex-wrap: wrap;
    row-gap: @size-x2;
  }

  @media @1024 {
    .flex-column(14px);

    align-items: start;
    padding: 0;
  }
}
</style>
